// polyfills
import 'babel-polyfill';
import 'element-closest';
import './polyfill';

import './windowExports';

// source
import './web';
import './configureWeb';
import './configurePartialUpdate';
//import './configureTurbolinks';

// css
import '../css-scss/main.scss';



// WEBPACK FOOTER //
// ./fe/web-kanken/src/js/index.js